import { render, staticRenderFns } from "./EtcList.vue?vue&type=template&id=25d36464"
import script from "./EtcList.vue?vue&type=script&lang=js"
export * from "./EtcList.vue?vue&type=script&lang=js"
import style0 from "./EtcList.vue?vue&type=style&index=0&id=25d36464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports